import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from "react";
import styles from "./compare-bar.module.css";
import { HeartFilledIcon, HeartOutlineIcon } from "@cinch-nx/design-system-icons";
import cx from "classnames";
export var CompareIcon = function(param) {
    var isToggled = param.isToggled;
    return /*#__PURE__*/ _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        fill: "currentColor",
        viewBox: "0 0 16 16",
        className: styles.compareCtaIcon,
        "aria-hidden": "true",
        children: isToggled ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx("path", {
                    d: "M14 13a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3a1 1 0 0 1 1-1h9a1 1 0 1 0 0-2H3a3 3 0 0 0-3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8a1 1 0 1 0-2 0v5Z"
                }),
                /*#__PURE__*/ _jsx("path", {
                    d: "M4.262 7.452a.75.75 0 1 0-1.024 1.096l1.024-1.096ZM7.5 11.5l-.512.548a.75.75 0 0 0 1.059-.034L7.5 11.5Zm8.297-7.736a.75.75 0 0 0-1.094-1.028l1.094 1.028ZM3.238 8.548l3.75 3.5 1.024-1.096-3.75-3.5-1.024 1.096Zm4.809 3.466 7.75-8.25-1.094-1.028-7.75 8.25 1.094 1.027Z"
                })
            ]
        }) : /*#__PURE__*/ _jsx("path", {
            d: "M 14 13 a 1 1 0 0 1 -1 1 H 3 a 1 1 0 0 1 -1 -1 V 3 a 1 1 0 0 1 1 -1 h 10 V 0 H 3 a 3 3 0 0 0 -3 3 v 10 a 3 3 0 0 0 3 3 h 10 a 3 3 0 0 0 3 -3 V 3 a 3 3 0 0 0 -3 -3 V 2 A 1 1 0 0 1 14 3 z"
        })
    });
};
export var FavouriteIcon = function(param) {
    var isToggled = param.isToggled;
    return isToggled ? /*#__PURE__*/ _jsx(HeartFilledIcon, {
        size: 16
    }) : /*#__PURE__*/ _jsx(HeartOutlineIcon, {
        size: 16
    });
};
export var CompareBar = function() {
    //TODO: Functionality replaced by compare/favourite provider in future
    var ref = useState(false), isCompareToggled = ref[0], setIsCompareToggled = ref[1];
    var ref1 = useState(false), isFavouriteToggled = ref1[0], setIsFavouriteToggled = ref1[1];
    var handleCompareOnClick = function() {
        setIsCompareToggled(!isCompareToggled);
    };
    var handleFavouriteOnClick = function() {
        setIsFavouriteToggled(!isFavouriteToggled);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.container,
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: styles.ctaWrapper,
                children: /*#__PURE__*/ _jsxs("button", {
                    className: cx(styles.ctaButton, isCompareToggled && styles.toggled),
                    onClick: function() {
                        return handleCompareOnClick();
                    },
                    children: [
                        /*#__PURE__*/ _jsx(CompareIcon, {
                            isToggled: isCompareToggled
                        }),
                        " Compare"
                    ]
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.ctaWrapper,
                children: /*#__PURE__*/ _jsxs("button", {
                    className: cx(styles.ctaButton, isFavouriteToggled && styles.toggled),
                    onClick: function() {
                        return handleFavouriteOnClick();
                    },
                    children: [
                        /*#__PURE__*/ _jsx(FavouriteIcon, {
                            isToggled: isFavouriteToggled
                        }),
                        " Favourite"
                    ]
                })
            })
        ]
    });
};
